<template>
    <div class="py-12" v-observe-visibility="visibilityChanged">
        <div class="flex justify-center text-grey-dark" v-if="showButtons">
            <button
                @click="filter = 'accommodations'"
                class="uppercase text-sm py-4 px-6 focus:outline-none"
                :class="{
                    'bg-collection-teal text-white ':
                        filter === 'accommodations',
                    'border border-grey-lighter ': filter !== 'accommodations',
                }"
            >
                Accommodations
            </button>
            <button
                @click="filter = 'dining'"
                class="mx-6 uppercase text-sm py-4 px-6 focus:outline-none"
                :class="{
                    'bg-collection-teal text-white ': filter === 'dining',
                    'border border-grey-lighter ': filter !== 'dining',
                }"
            >
                Dining &amp; Drinks
            </button>
            <button
                @click="filter = 'ttd'"
                class="uppercase text-sm py-4 px-6 focus:outline-none"
                :class="{
                    'bg-collection-teal text-white ': filter === 'ttd',
                    'border border-grey-lighter ': filter !== 'ttd',
                }"
            >
                Things To Do
            </button>
        </div>
        <div class="w-full flex justify-center">
            <div class="container flex flex-col md:flex-row py-12">
                <transition-group
                    tag="div"
                    name="fade"
                    class="relative p-4 md:p-0 w-full md:w-1/2"
                    style="min-height: 400px"
                >
                    <div
                        v-if="filter === 'accommodations'"
                        key="accommodations"
                    >
                        <div
                            class="absolute top-0 left-0 feature-dining-image1"
                            style="opacity: 0"
                        >
                            <img
                                v-devise-image="{
                                    image: devise.accommodationsImage1,
                                    breakpoint: breakpoint,
                                }"
                                v-if="devise.accommodationsImage1.url"
                            />
                        </div>
                        <div
                            class="hidden md:block absolute top-0 left-0 -ml-16 mt-48 feature-dining-image2 shadow-2xl"
                            style="opacity: 0"
                        >
                            <img
                                v-devise-image="{
                                    image: devise.accommodationsImage2,
                                    breakpoint: breakpoint,
                                }"
                                v-if="devise.accommodationsImage2.url"
                            />
                        </div>
                    </div>
                    <div v-if="filter === 'dining'" key="dining">
                        <div class="absolute top-0 left-0">
                            <img
                                v-devise-image="{
                                    image: devise.diningImage1,
                                    breakpoint: breakpoint,
                                }"
                                v-if="devise.diningImage1.url"
                            />
                        </div>
                        <div class="absolute top-0 left-0 -ml-8 mt-18">
                            <img
                                v-devise-image="{
                                    image: devise.diningImage2,
                                    breakpoint: breakpoint,
                                }"
                                v-if="devise.diningImage2.url"
                            />
                        </div>
                    </div>
                    <div v-if="filter === 'ttd'" key="ttd">
                        <div class="absolute top-0 left-0">
                            <img
                                v-devise-image="{
                                    image: devise.ttdImage1,
                                    breakpoint: breakpoint,
                                }"
                                v-if="devise.ttdImage1.url"
                            />
                        </div>
                        <div class="absolute top-0 left-0 -ml-8 mt-18">
                            <img
                                v-devise-image="{
                                    image: devise.ttdImage2,
                                    breakpoint: breakpoint,
                                }"
                                v-if="devise.ttdImage2.url"
                            />
                        </div>
                    </div>
                </transition-group>
                <div class="w-full md:w-1/2 p-4 md:p-12">
                    <transition mode="out-in" tag="div" name="fade">
                        <div
                            v-show="filter === 'accommodations'"
                            key="accommodations-text"
                        >
                            <h3
                                v-if="devise.accommodationsTitle.text"
                                class="font-sans-lato font-bold text-3xl mb-4"
                            >
                                {{ devise.accommodationsTitle.text }}
                            </h3>
                            <div
                                v-html="devise.accommodationsDescription.text"
                            ></div>
                            <div class="grid grid-cols-4 md:grid-cols-5">
                                <div v-if="showIcons.bath" :style="iconStyles">
                                    <div>
                                        <bath
                                            :color="color"
                                            :w="iconWidth * 1.1"
                                            :h="iconHeight * 1.1"
                                        />
                                    </div>
                                    <div
                                        class="mt-1"
                                        v-html="
                                            lang.playaresorts[
                                                'double-jetted-tub'
                                            ]
                                        "
                                    />
                                </div>
                                <div v-if="showIcons.wifi" :style="iconStyles">
                                    <div>
                                        <wifi
                                            :color="color"
                                            :w="iconWidth * 0.8"
                                            :h="iconHeight * 0.8"
                                        />
                                    </div>
                                    <div
                                        class="mt-1"
                                        v-html="lang.playaresorts['wifi']"
                                    />
                                </div>
                                <div
                                    v-if="showIcons.roomService"
                                    :style="iconStyles"
                                >
                                    <div>
                                        <twenty-four-hour-room-service
                                            :color="color"
                                            :w="iconWidth * 0.8"
                                            :h="iconHeight * 0.8"
                                        />
                                    </div>
                                    <div
                                        class="mt-1"
                                        v-html="
                                            lang.playaresorts['room-service']
                                        "
                                    />
                                </div>
                                <div v-if="showIcons.bed" :style="iconStyles">
                                    <div>
                                        <bed
                                            :color="color"
                                            :w="iconWidth * 0.9"
                                            :h="iconHeight * 0.9"
                                        />
                                    </div>
                                    <div
                                        class="mt-1"
                                        v-html="
                                            lang.playaresorts['pillow-menu']
                                        "
                                    />
                                </div>
                                <div v-if="showIcons.bar" :style="iconStyles">
                                    <div>
                                        <bar
                                            :color="color"
                                            :w="iconWidth * 0.8"
                                            :h="iconHeight * 0.9"
                                        />
                                    </div>
                                    <div
                                        class="mt-1"
                                        v-html="lang.playaresorts['mini-bar']"
                                    />
                                </div>
                                <div v-if="showIcons.tv" :style="iconStyles">
                                    <div>
                                        <tv
                                            :color="color"
                                            :w="iconWidth * 0.8"
                                            :h="iconHeight * 0.8"
                                        />
                                    </div>
                                    <div
                                        class="mt-1"
                                        v-html="
                                            lang.playaresorts['flat-screen-tv']
                                        "
                                    />
                                </div>
                                <div
                                    v-if="showIcons.magicBox"
                                    :style="iconStyles"
                                >
                                    <div>
                                        <magic-box
                                            :color="color"
                                            :w="iconWidth * 0.8"
                                            :h="iconHeight * 0.8"
                                        />
                                    </div>
                                    <div
                                        class="mt-1"
                                        v-html="lang.playaresorts['magic-box']"
                                    />
                                </div>
                                <div v-if="showIcons.robe" :style="iconStyles">
                                    <div>
                                        <robe
                                            :color="color"
                                            :w="iconWidth * 0.8"
                                            :h="iconHeight * 0.8"
                                        />
                                    </div>
                                    <div
                                        class="mt-1"
                                        v-html="lang.playaresorts['robes']"
                                    />
                                </div>
                                <div
                                    v-if="showIcons.mirror"
                                    :style="iconStyles"
                                >
                                    <div>
                                        <mirror
                                            :color="color"
                                            :w="iconWidth * 0.8"
                                            :h="iconHeight * 0.8"
                                        />
                                    </div>
                                    <div
                                        class="mt-1"
                                        v-html="lang.playaresorts['mirror']"
                                    />
                                </div>
                                <div
                                    v-if="showIcons.bathroom"
                                    :style="iconStyles"
                                >
                                    <div>
                                        <bathroom
                                            :color="color"
                                            :w="iconWidth * 0.9"
                                            :h="iconHeight * 0.9"
                                        />
                                    </div>
                                    <div
                                        class="mt-1"
                                        v-html="
                                            lang.playaresorts[
                                                'bathroom-amenaties'
                                            ]
                                        "
                                    />
                                </div>
                                <div v-if="showIcons.safe" :style="iconStyles">
                                    <div>
                                        <safe
                                            :color="color"
                                            :w="iconWidth * 0.8"
                                            :h="iconHeight * 0.8"
                                        />
                                    </div>
                                    <div
                                        class="mt-1"
                                        v-html="
                                            lang.playaresorts['in-room-safe']
                                        "
                                    />
                                </div>

                                <div v-if="showIcons.patio" :style="iconStyles">
                                    <div>
                                        <patio
                                            :color="color"
                                            :w="iconWidth * 0.8"
                                            :h="iconHeight * 0.8"
                                        />
                                    </div>
                                    <div
                                        class="mt-1"
                                        v-html="
                                            lang.playaresorts['furnished-patio']
                                        "
                                    />
                                </div>
                                <div v-if="showIcons.phone" :style="iconStyles">
                                    <div>
                                        <phone-amenity
                                            :color="color"
                                            :w="iconWidth * 0.8"
                                            :h="iconHeight * 0.8"
                                        />
                                    </div>
                                    <div
                                        class="mt-1"
                                        v-html="lang.playaresorts['telephone']"
                                    />
                                </div>
                                <div
                                    v-if="showIcons.coffee"
                                    :style="iconStyles"
                                >
                                    <div>
                                        <coffee
                                            :color="color"
                                            :w="iconWidth * 0.8"
                                            :h="iconHeight * 0.8"
                                        />
                                    </div>
                                    <div
                                        class="mt-1"
                                        v-html="
                                            lang.playaresorts['coffee-maker']
                                        "
                                    />
                                </div>
                                <div v-if="showIcons.ac" :style="iconStyles">
                                    <div>
                                        <a-c
                                            :color="color"
                                            :w="iconWidth * 1"
                                            :h="iconHeight * 1"
                                        />
                                    </div>
                                    <div
                                        class="mt-1"
                                        v-html="
                                            lang.playaresorts[
                                                'air-conditioning'
                                            ]
                                        "
                                    />
                                </div>
                                <div
                                    v-if="showIcons.hairdryer"
                                    :style="iconStyles"
                                >
                                    <div>
                                        <hairdryer
                                            :color="color"
                                            :w="iconWidth * 0.8"
                                            :h="iconHeight * 0.8"
                                        />
                                    </div>
                                    <div
                                        class="mt-1"
                                        v-html="lang.playaresorts['hairdryer']"
                                    />
                                </div>
                                <div
                                    v-if="showIcons.ironingBoard"
                                    :style="iconStyles"
                                >
                                    <div>
                                        <ironing-board
                                            :color="color"
                                            :w="iconWidth * 0.8"
                                            :h="iconHeight * 0.8"
                                        />
                                    </div>
                                    <div
                                        class="mt-1"
                                        v-html="
                                            lang.playaresorts[
                                                'iron-and-ironing-board'
                                            ]
                                        "
                                    />
                                </div>
                                <div v-if="showIcons.alarm" :style="iconStyles">
                                    <div>
                                        <alarm
                                            :color="color"
                                            :w="iconWidth * 0.9"
                                            :h="iconHeight * 0.9"
                                        />
                                    </div>
                                    <div
                                        class="mt-1"
                                        v-html="
                                            lang.playaresorts['alarm-clock']
                                        "
                                    />
                                </div>
                                <div
                                    v-if="showIcons.balcony"
                                    :style="iconStyles"
                                >
                                    <div>
                                        <balcony
                                            :color="color"
                                            :w="iconWidth * 0.9"
                                            :h="iconHeight * 0.9"
                                        />
                                    </div>
                                    <div
                                        class="mt-1"
                                        v-html="
                                            lang.playaresorts['private-balcony']
                                        "
                                    />
                                </div>
                                <div v-if="showIcons.radio" :style="iconStyles">
                                    <div>
                                        <radio
                                            :color="color"
                                            :w="iconWidth * 0.8"
                                            :h="iconHeight * 0.8"
                                        />
                                    </div>
                                    <div
                                        class="mt-1"
                                        v-html="lang.playaresorts['radio']"
                                    />
                                </div>
                                <div
                                    v-if="showIcons.turndown"
                                    :style="iconStyles"
                                >
                                    <div>
                                        <turndown
                                            :color="color"
                                            :w="iconWidth * 0.8"
                                            :h="iconHeight * 0.8"
                                        />
                                    </div>
                                    <div
                                        class="mt-1"
                                        v-html="
                                            lang.playaresorts[
                                                'turndown-service'
                                            ]
                                        "
                                    />
                                </div>
                                <div
                                    v-if="showIcons.bluetooth"
                                    :style="iconStyles"
                                >
                                    <div>
                                        <bluetooth-speaker
                                            :color="color"
                                            :w="iconWidth * 0.8"
                                            :h="iconHeight * 0.8"
                                        />
                                    </div>
                                    <div
                                        class="mt-1"
                                        v-html="
                                            lang.playaresorts[
                                                'bluetooth-speaker'
                                            ]
                                        "
                                    />
                                </div>
                                <div
                                    v-if="showIcons.butler"
                                    :style="iconStyles"
                                >
                                    <div>
                                        <butler
                                            :color="color"
                                            :w="iconWidth * 0.8"
                                            :h="iconHeight * 0.8"
                                        />
                                    </div>
                                    <div
                                        class="mt-1"
                                        v-html="
                                            lang.playaresorts['butler-service']
                                        "
                                    />
                                </div>
                                <div
                                    v-if="showIcons.liquor"
                                    :style="iconStyles"
                                >
                                    <div>
                                        <liquor
                                            :color="color"
                                            :w="iconWidth * 0.8"
                                            :h="iconHeight * 0.8"
                                        />
                                    </div>
                                    <div
                                        class="mt-1"
                                        v-html="lang.playaresorts['beer-wine']"
                                    />
                                </div>
                                <div
                                    v-if="showIcons.showers"
                                    :style="iconStyles"
                                >
                                    <div>
                                        <showers
                                            :color="color"
                                            :w="iconWidth * 0.8"
                                            :h="iconHeight * 0.8"
                                        />
                                    </div>
                                    <div
                                        class="mt-1"
                                        v-html="
                                            lang.playaresorts[
                                                'rainfall-showers'
                                            ]
                                        "
                                    />
                                </div>
                                <div
                                    v-if="showIcons.slippers"
                                    :style="iconStyles"
                                >
                                    <div>
                                        <slippers
                                            :color="color"
                                            :w="iconWidth * 0.8"
                                            :h="iconHeight * 0.8"
                                        />
                                    </div>
                                    <div
                                        class="mt-1"
                                        v-html="
                                            lang.playaresorts['robes-slippers']
                                        "
                                    />
                                </div>
                                <div
                                    v-if="showIcons.transfers"
                                    :style="iconStyles"
                                >
                                    <div>
                                        <transfers
                                            :color="color"
                                            :w="iconWidth * 0.8"
                                            :h="iconHeight * 0.8"
                                        />
                                    </div>
                                    <div
                                        class="mt-1"
                                        v-html="lang.playaresorts['transfers']"
                                    />
                                </div>
                            </div>
                        </div>
                    </transition>
                    <transition mode="out-in" tag="div" name="fade">
                        <div v-show="filter === 'dining'" key="dining-text">
                            <h3
                                v-if="devise.diningTitle.text"
                                class="font-sans-lato font-bold text-3xl mb-4"
                            >
                                {{ devise.diningTitle.text }}
                            </h3>
                            <div v-html="devise.diningDescription.text"></div>
                        </div>
                    </transition>
                    <transition mode="out-in" tag="div" name="fade">
                        <div v-show="filter === 'ttd'" key="tdd-text">
                            <h3
                                v-if="devise.ttdTitle.text"
                                class="font-sans-lato font-bold text-3xl mb-4"
                            >
                                {{ devise.ttdTitle.text }}
                            </h3>
                            <div v-html="devise.ttdDescription.text"></div>
                        </div>
                    </transition>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import anime from 'animejs/lib/anime.es.js';
import AC from '@/components/amenaties-icons/AC';
import Alarm from '@/components/amenaties-icons/Alarm';
import Balcony from '@/components/amenaties-icons/Balcony';
import Bar from '@/components/amenaties-icons/Bar';
import Bath from '@/components/amenaties-icons/Bath';
import Bathroom from '@/components/amenaties-icons/Bathroom';
import Bed from '@/components/amenaties-icons/Bed';
import BluetoothSpeaker from '@/components/amenaties-icons/BluetoothSpeaker';
import Butler from '@/components/amenaties-icons/Butler';
import Coffee from '@/components/amenaties-icons/Coffee';
import Hairdryer from '@/components/amenaties-icons/Hairdryer';
import IroningBoard from '@/components/amenaties-icons/IroningBoard';
import Liquor from '@/components/amenaties-icons/Liquor';
import MagicBox from '@/components/amenaties-icons/MagicBox';
import Mirror from '@/components/amenaties-icons/Mirror';
import Patio from '@/components/amenaties-icons/Patio';
import PhoneAmenity from '@/components/amenaties-icons/PhoneAmenity';
import Radio from '@/components/amenaties-icons/Radio';
import Robe from '@/components/amenaties-icons/Robe';
import Safe from '@/components/amenaties-icons/Safe';
import Showers from '@/components/amenaties-icons/Showers';
import Slippers from '@/components/amenaties-icons/Slippers';
import Transfers from '@/components/amenaties-icons/Transfers';
import Turndown from '@/components/amenaties-icons/Turndown';
import Tv from '@/components/amenaties-icons/Tv';
import TwentyFourHourRoomService from '@/components/amenaties-icons/TwentyFourHourRoomService';
import Wifi from '@/components/amenaties-icons/Wifi';

export default {
    name: 'CollectionFeatures',

    components: {
        AC,
        Alarm,
        Balcony,
        Bar,
        Bath,
        Bathroom,
        Bed,
        BluetoothSpeaker,
        Butler,
        Coffee,
        Hairdryer,
        IroningBoard,
        Liquor,
        MagicBox,
        Mirror,
        Patio,
        PhoneAmenity,
        Radio,
        Robe,
        Safe,
        Showers,
        Slippers,
        Transfers,
        Turndown,
        Tv,
        TwentyFourHourRoomService,
        Wifi,
    },

    props: {
        showIcons: {
            type: Object,
            default: () => {
                return {
                    isVisible: false,
                    bath: true,
                    wifi: true,
                    roomService: true,
                    bed: true,
                    bar: true,
                    tv: true,
                    magicBox: true,
                    robe: true,
                    mirror: true,
                    bathroom: true,
                    safe: true,
                    patio: true,
                    phone: true,
                    coffee: true,
                    ac: true,
                    hairdryer: true,
                    ironingBoard: true,
                    alarm: true,
                    balcony: true,
                    radio: true,
                    turndown: true,
                    bluetooth: true,
                    butler: true,
                    liquor: true,
                    showers: true,
                    slippers: true,
                    transfers: true,
                };
            },
        },
    },

    data() {
        return {
            filter: 'accommodations',
            iconWidth: 40,
            iconHeight: 50,
            color: 'currentcolor',
        };
    },

    computed: {
        iconStyles() {
            return {
                marginLeft: `5px`,
                marginRight: `5px`,
                marginTop: `5px`,
                marginBottom: `5px`,
                textAlign: 'center',
                fontSize: '13px',
                width: `${this.iconWidth + 40}px`,
                height: `${this.iconHeight + 40}px`,
                display: 'flex',
                justifyContent: 'center',
                flexDirection: 'column',
                alignItems: 'center',
            };
        },
        showButtons() {
            let buttonCount = 0;
            if (this.devise.accommodationsTitle.text) {
                buttonCount++;
            }
            if (this.devise.diningTitle.text) {
                buttonCount++;
            }
            if (this.devise.ttdTitle.text) {
                buttonCount++;
            }

            return buttonCount > 1;
        },
    },

    methods: {
        visibilityChanged(isVisible) {
            this.isVisible = isVisible;

            if (this.isVisible) {
                anime({
                    targets: [
                        '.feature-dining-image1',
                        '.feature-dining-image2',
                    ],
                    opacity: 1,
                    duration: 3000,
                    easing: 'easeOutExpo',
                    delay: anime.stagger(1000),
                });
            } else {
                anime({
                    targets: [
                        '.feature-dining-image1',
                        '.feature-dining-image2',
                    ],
                    opacity: 0,
                    duration: 2000,
                });
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.fade-enter-active {
    transition: opacity 500ms;
}
.fade-leave-active {
    transition: all 0ms;
}
.fade-enter,
.fade-leave-to {
    opacity: 0;
    overflow: hidden;
}
</style>
